import { reportedTimeToLoggedTime } from "./reportedTimeToLoggedTime";
import { TimeReportAggregatedLoggedTime } from "./TimeReportAggregatedLoggedTime";
import { TimeReportLoggedTime } from "./TimeReportLoggedTime";

export const loggedTimeToAggregatedLoggedTime = (loggedTime: TimeReportLoggedTime): TimeReportAggregatedLoggedTime => {
  const result: TimeReportAggregatedLoggedTime = {
    daily: loggedTime.measureUnit === "DAILY" ? reportedTimeToLoggedTime(0, "DAILY") : undefined,
    hourly: loggedTime.measureUnit === "HOURLY" ? reportedTimeToLoggedTime(0, "HOURLY") : undefined,
    isEmpty: loggedTime.isEmpty,
    formattedAmount: loggedTime.formattedAmount,
  };

  switch (loggedTime.measureUnit) {
    case "DAILY":
      result.daily = loggedTime;
      break;
    case "HOURLY":
      result.hourly = loggedTime;
      break;
  }

  return result;
};
